import React from 'react';

type Props = {
  dimension?: number;
};

const Icon: React.FC<Props> = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
      stroke="#FBC02D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 16L12 12" stroke="#FBC02D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.0029 8L11.9939 8" stroke="#FBC02D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Icon;
